import { useEffect, useState } from 'react';

/**
 * The viewport width, as state, because the board's mobile decision is a FUNCTION of it
 * (`board-layout.ts`) rather than a CSS breakpoint.
 *
 * ⭐ Why not a media query in Tailwind: `hidden md:flex` would keep all six lanes in the DOM and hide
 * five of them, so a phone would still build them, and no test could read the decision. This hook
 * makes "one lane at a time below 768px" a thing the component obeys and a thing a test can assert.
 */
export function useViewportWidth(): number {
  const [width, setWidth] = useState(() =>
    typeof window === 'undefined' ? 1280 : window.innerWidth,
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    // Rotating a phone fires `orientationchange` before `resize` in some browsers; both are cheap.
    window.addEventListener('orientationchange', onResize);
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return width;
}
